module.exports = __webpack_public_path__ + "img/ealab_icon.a0d3a4b3.png";